/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { KpiType } from "~/constants";

export function getKpiFetchConfig(selectedType: KpiType) {
  return {
    fetchCostAllocation: selectedType === KpiType.COST_ALLOCATION_COVERAGE,
    fetchOverallWaste: selectedType === KpiType.OVERALL_WASTE,
    fetchNonProdHours: selectedType === KpiType.NON_PROD_HOURS,
  };
}
